import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import VM from 'scratch-vm';
import PaintEditor from 'scratch-paint';
import {inlineSvgFonts} from 'scratch-svg-renderer';

import {connect} from 'react-redux';

class PaintEditorWrapper extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleUpdateImage',
            'handleUpdateName'
        ]);
    }
    shouldComponentUpdate (nextProps) {
        // Also check if costume finished loading (skinId changed from null to a number)
        const currentCostume = this.props.vm.editingTarget && 
            this.props.vm.editingTarget.sprite &&
            this.props.vm.editingTarget.sprite.costumes[this.props.selectedCostumeIndex];
        const nextCostume = nextProps.vm.editingTarget && 
            nextProps.vm.editingTarget.sprite &&
            nextProps.vm.editingTarget.sprite.costumes[nextProps.selectedCostumeIndex];
        const costumeLoaded = currentCostume && currentCostume.skinId !== null && currentCostume.skinId !== undefined;
        const nextCostumeLoaded = nextCostume && nextCostume.skinId !== null && nextCostume.skinId !== undefined;
        
        return this.props.imageId !== nextProps.imageId ||
            this.props.rtl !== nextProps.rtl ||
            this.props.name !== nextProps.name ||
            costumeLoaded !== nextCostumeLoaded; // Re-render when costume finishes loading
    }
    handleUpdateName (name) {
        this.props.vm.renameCostume(this.props.selectedCostumeIndex, name);
    }
    handleUpdateImage (isVector, image, rotationCenterX, rotationCenterY) {
        if (isVector) {
            this.props.vm.updateSvg(
                this.props.selectedCostumeIndex,
                image,
                rotationCenterX,
                rotationCenterY);
        } else {
            this.props.vm.updateBitmap(
                this.props.selectedCostumeIndex,
                image,
                rotationCenterX,
                rotationCenterY,
                2 /* bitmapResolution */);
        }
    }
    render () {
        if (!this.props.imageId) return null;
        const {
            selectedCostumeIndex,
            vm,
            ...componentProps
        } = this.props;

        // Get the costume to check if it's loaded and valid
        const costumeImage = vm.getCostume(selectedCostumeIndex);
        // Also check if the costume has a skinId (meaning it's loaded in the renderer)
        const costume = vm.editingTarget && vm.editingTarget.sprite &&
            vm.editingTarget.sprite.costumes[selectedCostumeIndex];
        const isCostumeLoaded = costume && costume.skinId !== null && costume.skinId !== undefined;

        // Don't render if costume isn't loaded yet or image is null
        if (!isCostumeLoaded || !costumeImage) return null;

        return (
            <PaintEditor
                {...componentProps}
                image={costumeImage}
                onUpdateImage={this.handleUpdateImage}
                onUpdateName={this.handleUpdateName}
                fontInlineFn={inlineSvgFonts}
            />
        );
    }
}

PaintEditorWrapper.propTypes = {
    imageFormat: PropTypes.string.isRequired,
    imageId: PropTypes.string.isRequired,
    name: PropTypes.string,
    rotationCenterX: PropTypes.number,
    rotationCenterY: PropTypes.number,
    rtl: PropTypes.bool,
    selectedCostumeIndex: PropTypes.number.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = (state, {selectedCostumeIndex}) => {
    const targetId = state.scratchGui.vm.editingTarget.id;
    const sprite = state.scratchGui.vm.editingTarget.sprite;
    // Make sure the costume index doesn't go out of range.
    const index = selectedCostumeIndex < sprite.costumes.length ?
        selectedCostumeIndex : sprite.costumes.length - 1;
    const costume = state.scratchGui.vm.editingTarget.sprite.costumes[index];
    // Only create imageId if costume has a valid skinId (meaning it's loaded)
    const imageId = (targetId && costume && costume.skinId !== null && costume.skinId !== undefined) ?
        `${targetId}${costume.skinId}` : null;
    return {
        name: costume && costume.name,
        rotationCenterX: costume && costume.rotationCenterX,
        rotationCenterY: costume && costume.rotationCenterY,
        imageFormat: costume && costume.dataFormat,
        imageId: imageId,
        rtl: state.locales.isRtl,
        selectedCostumeIndex: index,
        vm: state.scratchGui.vm,
        zoomLevelId: targetId
    };
};

export default connect(
    mapStateToProps
)(PaintEditorWrapper);
